import axios from "axios";

class PageMetricsService {
  getPageMetrics(itemid, pageIdHash, start, end) {
    return axios
      .get('/sitecore/shell/client/Applications/altola/insights/data/content-matrix.all.json')
      .then(res => {

        let pageMetrics = res.data;
        let result = pageMetrics.data.content.find((e) => e.key === pageIdHash);

        if (result === undefined) {
          return null;
        }

        let o =
        {
          totalRecordCount: null,
          timeResolution: null,
          messages: [],
          data: {
            localization: null,
            content: [result]
          }
        };

        return o;
      })
      .catch(error => { });
  }

  getPageVisitHistory(itemId, pageIdHash, start, end) {
    return axios
      .get('/sitecore/shell/client/Applications/altola/insights/data/page-visit-history.json')
      .then(res => res.data)
      .catch(error => { });
  }
}

export default new PageMetricsService();



// WEBPACK FOOTER //
// ./src/data/PageMetricsService.dev.js